import { Calendar } from './Calendar';
import { NewPost } from './NewPost';
import "../css/Home.css"
import { Helmet } from 'react-helmet';
import { NavLink} from "react-router-dom";


export const Home = () => {
  return (
    <>
      <Helmet>
        <title>有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
        <meta name="description" content="大牟田・有明海で遊漁船を予約し、初心者も安心して楽しめる釣り体験を提供します。釣れる魚の種類や釣りスポットの紹介も！" />
        <meta name="keywords" content="大牟田遊漁船,三池港遊漁船,シーライン 大牟田,有明海 釣り船, 大牟田遊漁船,大牟田釣り船" />
        <meta property="og:url" content="https://sealine3-new.web.app/" />
        <link rel="canonical" href="https://sealine3-new.web.app/" />
      </Helmet>
      <img src="images/mainShip.webp" alt="シーラインⅢ" style={{ width: '100%' }} />
      {/* <div className="fuel-surcharge">
        <h1>【重要】燃料費高騰に伴うサーチャージのお願い</h1>
        <p>平素より当船をご利用いただき誠にありがとうございます。昨今の燃料費高騰により運航コストが大幅に増加しております。</p>
        <p>お客様には大変ご迷惑をおかけしますが、2026年3月23日よりお一人様1,000円の燃料サーチャージをご相談させていただきます。</p>
        <p>安全で安定した出船を継続するため、何卒ご理解のほどよろしくお願いいたします。</p>
      </div> */}
      <div style={{ padding: '5%' }}>
        <h2>船長より</h2>
        <section className="Ship">
          <p>
            大牟田市三池港発のスーパー遊漁船 シーラインです！<br />
            有明海・天草沖でタイ、ヒラメ、アラカブ、キスなど<br />
            趣味から本格的な釣りまでお楽しみ頂けます。<br />
            ☆初者でも大丈夫！グループや家族連れも大歓迎です！<br />
            クルージングだけでも楽しめます。<br />
            近場ヒラメ4人以上から9000円です
          </p>
          <a className="ad" href="https://ameblo.jp/sealine3">釣果(アメブロ)</a>
          <div style={{ "padding": "10px 10px 10px 10px", "fontSize": "20px" }}>←クリック</div>
        </section>
        <section className="Ship">
          <h3>釣り好き船長といざ！出港！</h3>
          <p>
            釣った魚は大牟田市の『一期一会』『肥後っこ』で<br />調理していただくこともできます。<br />
            お食事もできますので、仲間やご家族と一緒にいかがでしょうか?<br />
            お気軽に船長までお尋ねください。<br />
          </p>
          <br />
          <Calendar />
          <div className="gradient-background">
          </div>
          <div style={{ "backgroundColor": "white", "padding": "20px" }}>
            <div>
              <p style={{
                "color": "black",
                "fontSize": "30px",
                "borderBottom": "black dotted",
                "textShadow": "2px 2px 4px rgba(0, 0, 0, 0.7)",
                "margin": 0
              }}>
                New Post</p>
            </div>
            <NewPost />
            <p style={{ textAlign: "right" }}>
              <NavLink
                style={{
                  fontSize: "20px",
                  textDecoration: "underline",
                  color: "black"
                }}
                activeClassName="active"
                exact
                to="/BlogList"
              >
                &gt;&gt;すべて表示
              </NavLink>
            </p>
          </div>
          <div className="Address">
            <h2>アクセス</h2>
            <p style={{ "textAlign": "left" }}>
              〇三池港<br />
              〒836-0061<br />
              福岡県大牟田市新港町４<br />
            </p>
            <iframe title="googoleMap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3345.860900009138!2d130.41541837546987!3d33.00744257356818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35404510a0ec91d9%3A0x714e081061da70be!2z6Yej44KK6Ii5IOOCt-ODvOODqeOCpOODsw!5e0!3m2!1sja!2sjp!4v1727521960179!5m2!1sja!2sjp" ></iframe><br />
          </div>
        </section>
      </div>
    </>
  );
};
